export default {"src":"/_next/static/media/walletConnect.54dd2caa.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};